import CondType from "../../../../../src/docs/CondType";
import React from 'react';
export default {
  CondType,
  React
};